import { Box, Stack } from "@mui/material";
import { useDocumentListContext } from "../DocumentationContext";
// import { DocumentUpload } from "./DocumentUpload/DocumentUpload";
import { useTranslation } from "react-i18next";
import { TitleSearch } from "src/components/Grid/TitleSearch";
import { styles } from "./styles/DocumentationListGridHeader";
// import { CREATE, MEDIA_CONTENT, useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
// import { useFoodpilotContext } from "src/context/FoodpilotContext.tsx";

export const DocumentationListGridHeader = () => {
    const { totalItems, delayedSearchQuery } = useDocumentListContext();
    const { delayedSearch, resetSearch } = delayedSearchQuery;
    const { t } = useTranslation();
    // const { canUser } = useFoodpilotContext();

    return (
        <Box sx={styles.container}>
            <Stack direction="row" useFlexGap justifyContent="space-between" alignItems="center">
                <Stack direction="row" useFlexGap gap="12px">
                    <TitleSearch
                        title={t("documentation.alldocuments", "All documents")}
                        search={delayedSearch}
                        totalItems={totalItems ?? 0}
                        resetSearch={resetSearch}
                    />
                </Stack>
                {/* {canUser(CREATE, MEDIA_CONTENT) && (
                    <Stack direction="row" useFlexGap gap="12px">
                        <DocumentUpload />
                    </Stack>
                )} */}
            </Stack>

            <Stack
                direction="row"
                useFlexGap
                justifyContent="space-between"
                alignItems="center"
                sx={styles.stackMargin}
            />
        </Box>
    );
};
